import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { ConventionQualifiedtoReceive } from 'app/models/convention-qualifiedto-receive.model';
import { EventConvention } from 'app/models/event-convention.model';
import { ConventionDatesControlExtension } from 'app/models/extensions/convention-dates-control-extension.model';

export class ConventionDatesControl extends ConventionDatesControlExtension {
  conventionDatesControlDBID: number = 0;
  credentialMailingStartDT: Date = new Date();
  credentialGenerationStopDT: Date = new Date();
  qualifyToSitPaidMonth: Date = new Date();
  membershipAvgCalcStartDT: Date = new Date();
  membershipAvgCalcEndDT: Date = new Date();
  createdDT: Date = new Date();
  createdBy: string = null;
  modifiedDT: Date = new Date();
  modifiedBy: string = null;
  rowVersion: number = 0;
  conventionQualifiedtoReceives: ConventionQualifiedtoReceive[] = [];
  eventConventions: EventConvention[] = [];

  static getForm(disableAll: boolean = false, includeNav: string[] = []): FormGroup {
    const form = new FormGroup({
      conventionDatesControlDBID: new FormControl({ value: 0, disabled: disableAll }),
      credentialMailingStartDT: new FormControl({ value: new Date(), disabled: disableAll }, [Validators.required]),
      credentialGenerationStopDT: new FormControl({ value: new Date(), disabled: disableAll }, [Validators.required]),
      qualifyToSitPaidMonth: new FormControl({ value: new Date(), disabled: disableAll }, [Validators.required]),
      membershipAvgCalcStartDT: new FormControl({ value: new Date(), disabled: disableAll }, [Validators.required]),
      membershipAvgCalcEndDT: new FormControl({ value: new Date(), disabled: disableAll }, [Validators.required]),
      createdDT: new FormControl({ value: new Date(), disabled: disableAll }, [Validators.required]),
      createdBy: new FormControl({ value: null, disabled: disableAll }, [Validators.maxLength(50)]),
      modifiedDT: new FormControl({ value: new Date(), disabled: disableAll }, [Validators.required]),
      modifiedBy: new FormControl({ value: null, disabled: disableAll }, [Validators.maxLength(50)]),
      rowVersion: new FormControl({ value: 0, disabled: disableAll }),
      conventionQualifiedtoReceives: new FormArray([]),
      eventConventions: new FormArray([])
    });


    return form;
  }
}